import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Btn, Image, P, LI, UL } from '../../../AbstractElements';
import { Logout } from '../../../Utils/Constants';
import { dynamicImage } from '../../../Utils';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../redux-toolkit/store';
import { useLiveQuery } from 'dexie-react-hooks';
import { profileHeaderData } from '../../../Data/HeaderData/RightHeaderData'
import { Href } from '../../../Utils/Constants';
import Dexie from 'dexie';
import { db } from '../../../db/userDB';
import { accessDB } from '../../../db/accessDB';
import { setAccess } from '../../../Utils/accessControl';
import FeatherIconCom from '../../../Utils/CommonComponents/CommonIcons/FeatherIconCom';
import { getEmployee, getFirstNamesFromEmployee, getPositions } from '../../../db/InitDexie';
import { NavItem } from 'reactstrap';
import CategoryModal from '../../../Components/Apps/Contacts/LeftContactAside/ContactModals/CategoryModal';
import { Col, Form, FormGroup, Input, Label, Modal, ModalBody, ModalHeader, Row } from 'reactstrap';
import { API } from '../../../api/API';
import { getData, postData } from '../../../CommonElements/Functions/PostGetFun';
import { toast } from 'react-toastify';
import { ensureDexieReady, getDataFromDexie, getDataFromDexiebyField, getDB } from '../../../db/DexieServises';
import { resetOrgUnit } from '../../../redux-toolkit/reducers/OrgUnitSlice';
import { setPositions, setDateRange } from '../../../redux-toolkit/positionSlice';

const ProfileHeader: React.FC = () => {
    const navigate = useNavigate();
    const [modal, setModal] = useState(false);
    const toggle = () => setModal(!modal);
    const appToken = localStorage.getItem('appToken')
    const serverUrl = localStorage.getItem('serverUrl');
    const url = `${serverUrl}${API.changePassword}`;
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [reEnterPassword, setReEnterPassword] = useState('');
    const unitName = useSelector((state: RootState) => state.orgUnit.name);
    const unitId = useSelector((state: RootState) => state.orgUnit.id);
    // const savedUnit = localStorage.getItem('selectedOrgUnit');
    console.log(unitName, unitId, 'savedUnit');
    const [empId, setEmpId] = useState(null);


    const [error, setError] = useState('');
    const dispatch = useDispatch<AppDispatch>();
    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        if (newPassword !== reEnterPassword) {
            setError('❌ New passwords do not match');
            return;
        }

        setError(''); // Clear previous errors

        const payload = {
            oldpwd: oldPassword,
            newpwd: newPassword,
            renewpwd: reEnterPassword,
        };

        const { status, data } = await postData(url, true, {
            oldpwd: oldPassword,
            newpwd: newPassword,
            renewpwd: reEnterPassword,
        }); // Safely handles null

        if (status === 200) {
            toast.success(data.message || "Password Change Success...!");
        } else {
            toast.error(data.message || "Can't change password");
        }
        setModal(!modal);
        // console.log('🔐 Submitted:', payload);
        // console.log('🔐 Response:', data.message, status);
    };

    const accessData = useLiveQuery(() => accessDB.access.toArray());
    const [clicks, setClicks] = useState(0);
    const [clicks1, setClicks1] = useState(0);
    const canAccess = accessData?.[0]?.canAccess ?? false;
    const [firstNames, setFirstNames] = useState(null);
    const [userNames, setUserNames] = useState(null);
    const [positionName, setpositionName] = useState('');

    useEffect(() => {
        const fetchFirstNames = async () => {
            // console.log('🚨 fetchFirstNames started');
            try {
                // console.log('✅ setAccess done');
                await setAccess(false);

                // console.log('✅ ensureDexieReady done');
                await ensureDexieReady();
                // console.log('✅ fetched User');
                const userdata = await getDataFromDexie('User');
                setUserNames(userdata?.[0]?.Username);

                // console.log('✅ fetched Employee');
                const rawData = await getDataFromDexie('Employee');


                // console.log('✅ fetched Position');
                const filteredPosition = await getDataFromDexiebyField("Position", {
                    field: "PositionId",
                    value: rawData?.[0]?.PositionId,
                });

                console.log(rawData?.[0], '✅ userdata');
                // console.log(filteredPosition, '✅ filteredPosition');

                setpositionName(filteredPosition?.[0]?.PositionName);
                setFirstNames(rawData?.[0]?.FirstName);
                setEmpId(rawData?.[0]?.EmployeeId);

                // localStorage.setItem("empId", rawData?.[0]?.EmployeeId);
                // localStorage.setItem("positionId", rawData?.[0]?.PositionId);
                // localStorage.setItem("orgUnitId", rawData?.[0]?.OrgUnitId);
                // localStorage.setItem("employeeCode", rawData?.[0]?.EmployeeCode);
            } catch (error) {
                console.error("❌ Failed to fetch first names:", error);
            }
        };

        fetchFirstNames();
    }, []);

    const handleClick = async () => {
        const newClicks = clicks + 1;
        setClicks(newClicks);

        let db1;
        try {
            db1 = await getDB();
        } catch {
            return;
        }

        const tableNames = db1.tables.map((table) => table.name);
        console.log('📋 Tables in DB:', tableNames);
        const appToken = localStorage.getItem('appToken')
        console.log(appToken, 'appToken');
        if (newClicks >= 7) {
            // localStorage.setItem("canAccess", 'true');

            await setAccess(true);
            setClicks(0);
            navigate('/me');
            console.log('Can Access:', canAccess);
        }
    };

    const handleClick1 = async () => {
        const newClicks1 = clicks1 + 1;
        setClicks1(newClicks1);

        if (newClicks1 >= 7) {
            // localStorage.setItem("canAccess", 'false');
            await setAccess(false);
            setClicks1(0);
            navigate('/me');
            console.log('Can Access:1', canAccess);
        }
    };

    const logout = async () => {
        await Dexie.delete('DynamicDB');
        dispatch(resetOrgUnit());
        dispatch(setPositions([]));
        dispatch(setDateRange({ start: '', end: '' }));
        localStorage.removeItem('dexie_dynamic_version');
        localStorage.removeItem('dexie_schema_hash');
        localStorage.removeItem('dexie_all_schema');
        localStorage.clear();
    };
    const positionid = localStorage.getItem('positionId')
    const today = new Date();
    const startDate = today.toISOString().split('T')[0]; // gives YYYY-MM-DD
    console.log(positionid,startDate,empId ,'============userdata');
    const handleClick2 = () => {
        navigate('/newProfile', {
            state: { employeeId: empId, tdate: startDate, positionId: positionid }
        });
        // navigate('/newProfile', {
        //     state: { employeeId: empId }
        // });
    };

    return (
        <LI className="profile-nav onhover-dropdown p-0 ">
            <div className="d-flex align-items-center profile-media">
                <div onClick={handleClick} style={{ cursor: 'pointer', margin: 5 }}>
                    <Image
                        className="b-r-10 img-40"

                        src={dynamicImage('dashboard/profile.png')}
                        alt="profile"
                    />
                </div>
                <div onClick={handleClick1} style={{ cursor: 'pointer' }} className="flex-grow-1">
                    <span>{firstNames || userNames || 'Name'}</span>
                    <P className="m-0">{positionName || ''} 
                      {positionName && <i className="middle fa fa-angle-down"></i>}
                    </P>

                    <ul>
                        {/* {firstNames.map((name, index) => (
                            <li key={index}>{name}</li>
                        ))} */}
                    </ul>
                </div>
            </div>
            <UL className="profile-dropdown onhover-show-div simple-list border p-2" style={{ width: '170px' }}>
                <LI >
                    <div onClick={handleClick2} style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', paddingTop: 0, }}>
                        <FeatherIconCom iconName={'User'} className='text-dark' />
                        <span style={{ color: '#222', marginLeft: 5, borderBottom: 1 }} >
                            {'Account'}
                        </span>
                    </div>
                </LI>
                {/* <LI >
                    <Link to={'/profile'}>
                        <FeatherIconCom iconName={'User'} className='text-dark ' />
                        <span style={{ color: '#222', marginLeft: 5 }}>{'Account'}</span></Link>
                </LI> */}
                <LI >

                    <FeatherIconCom iconName={'Lock'} className='text-dark' />
                    <span style={{ color: '#222', marginLeft: 5, paddingTop: 5, borderBottom: 1 }} onClick={toggle} >{'Change Password'}</span>


                </LI>
                <LI>
                    <Link onClick={logout} to="/login">
                        <FeatherIconCom iconName={"LogIn"} className='text-dark' />
                        <span style={{ color: '#222', marginLeft: 5, paddingTop: 5, }}>{Logout}</span>
                    </Link>
                </LI>
            </UL>

            <NavItem>

                <Modal isOpen={modal} toggle={toggle}>
                    <ModalHeader toggle={toggle}>{'Change Password'}</ModalHeader>
                    <ModalBody>
                        <Form className="form-bookmark" onSubmit={handleSubmit}>
                            <Row className="g-2">
                                <Col md={12}>
                                    <FormGroup>
                                        <Label>{'Old Password'}</Label>
                                        <Input type="text" required placeholder="Enter Old  Password" value={oldPassword}
                                            onChange={(e) => setOldPassword(e.target.value)} />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row className="g-2">
                                <Col md={12}>
                                    <FormGroup>
                                        <Label>{'New Password'}</Label>

                                        <Input type="password" required placeholder="Enter New Password" value={newPassword}
                                            onChange={(e) => setNewPassword(e.target.value)} />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row className="g-2">
                                <Col md={12}>
                                    <FormGroup>
                                        <Label>{'Re-Enter Password'}</Label>
                                        <Input
                                            type="password"
                                            required
                                            placeholder="Re-Enter Password"
                                            value={reEnterPassword}
                                            onChange={(e) => setReEnterPassword(e.target.value)}
                                            invalid={newPassword !== reEnterPassword}
                                        />
                                        {newPassword !== reEnterPassword && (
                                            <div style={{ color: 'red', marginTop: 4, fontSize: 13 }}>
                                                Passwords do not match
                                            </div>
                                        )}
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Btn color='secondary' className='me-2' >{'Save'}</Btn>
                            <Btn color='primary' onClick={toggle}>{'Cancel'}</Btn>
                        </Form>
                    </ModalBody>
                </Modal>
            </NavItem>
        </LI>
    );
};

export default ProfileHeader;
